import {Reducer} from "redux";
import {Action, ActionTypes} from "../Actions/ActionTypes";
import { ReduxState, SnackbarState, SnackbarStatus } from "../Definitions/Definitions";

const initialSnackbarState: SnackbarState = {
    status: SnackbarStatus.Closed,
    message: "",
    closeDelay: 2500
};

export const SnackbarReducer: Reducer<ReduxState['snackbarState'], Action> = (state = initialSnackbarState, action) => {
    switch (action.type) {
        case ActionTypes.OPEN_SNACKBAR:
            return {
                status: action.status,
                message: action.message,
                closeDelay: action.closeDelay
            };
        case ActionTypes.CLOSE_SNACKBAR:
            return {
                status: SnackbarStatus.Closed,
                message: "",
                closeDelay: 2500,
            };
    }
    return state;
};